Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById("archive-board-or-project")) {
        Global.components.push(
            new Vue({
                el: '#archive-board-or-project',
                store,
                data: function () {
                    return {
                        isArchived: false,
                        confirmMessage: 'Weet je het zeker?'
                    }
                },
                created: function() {
                },
                beforeMount: function() {
                    API.GET(this.$el.dataset.url).then(response => {
                        this.isArchived = response.data.archived;
                    });
                },
                mounted: function () {
                },
                computed: {
                    messageText: {
                        get: function () {
                            return this.$store.getters.messageText
                        },
                        set: function (newValue) {
                            this.$store.dispatch('setMessageText', newValue)
                        }
                    },
                    showMessage: {
                        get: function () {
                            return this.$store.getters.showMessage
                        },
                        set: function (newValue) {
                            this.$store.dispatch('setShowMessage', newValue)
                        }
                    }
                },
                watch: {},
                methods: {
                    confirm: function () {
                        if (confirm(this.$el.dataset.confirmMessage || this.confirmMessage) !== true) {
                            return false;
                        }

                        const that = this;

                        let data = new FormData();
                        data.append('_method', 'put');
                        data.append('archived', (this.isArchived ? 0 : 1));

                        API.POST(this.$el.dataset.url, data).then(response => {
                            that.messageText = response.message;
                            this.isArchived = response.data.archived;
                        });

                    }
                },
                created: function () {
                },
                destroyed: function () {
                }
            })
        )
    }
});
